import ChatbotIcon from '#/assets/svgs/ChatbotIcon.svg';
import { Loader, SimpleAlert } from '#/common/components';
import { ChatMessages, ChatbotHeader, FaqList, LeadForm, MessageInput, useChatbotWidget } from '..';

function ChatbotPreview() {
  const {
    alert,
    chatbotData,
    messages,
    isSending,
    isStreaming,
    streamingMessage,
    isFieldSubmit,
    inputField,
    leadFormik,
    isUploadFileLoading,
    reactions,
    renderLeadForm,
    updateMessages,
    handleChange,
    handleEnterKeyPress,
    submitForm,
    handleReaction,
    handleFileChange,
    handleTelInputChange,
    handleLeadFormClose,
    isResponsive,
    contentRef,
    faqContainerRef,
    additionalNoteRef,
    handleSelectChange,
    uploadedFiles,
    isProcessingFiles,
    handleRemoveFile,
    fileRef,
    isLeadSubmitLoading,
    isSubmissionSuccess,
    isPending,
    handleFaqStateChange,
    onResetChatAsync,
    onResetChatLoading,
    isConversationHistoryFetching,
    inputRef,
    streamingMessageRef,
  } = useChatbotWidget();

  const {
    setting: {
      botName = '',
      welcomeMessage = 'Hi, I am Alex',
      onlineStatus = 'online',
      color = '',
      textColor = '',
      whatsappAdded = false,
      whatsappNumber = '',
      faqs = [],
      additionalNoteEnabled = false,
      additionalNoteLinkText = '',
      additionalNoteText = '',
      privacyPolicyDocument = {},
      messagePlaceholder = 'Write a message',
      faqTextColor = '',
      faqBackgroundColor = '',
    } = {},
  } = chatbotData?.data || {};

  const chatBotImage = chatbotData?.data?.setting?.chatbotImage?.image || '';

  const closeShowPreview = () => {
    window.parent.postMessage({ action: 'close' }, '*');
  };

  const { lead } = renderLeadForm || {};

  return (
    <div
      className={`preview-content ${isResponsive ? 'responsive-preview-content' : ''}`}
      style={{
        '--chatbot-bg': color,
        '--chatbot-text-color': textColor,
        '--faq-text-color': faqTextColor,
        '--faq-background-color': faqBackgroundColor,
      }}
    >
      <SimpleAlert alert={alert.alert} />
      {isPending ? (
        <div className="chatbot-loader">
          <Loader size={52} />
        </div>
      ) : (
        <>
          <ChatbotHeader
            botName={botName}
            onlineStatus={onlineStatus}
            color={color}
            textColor={textColor}
            chatBotImage={chatBotImage}
            whatsappAdded={whatsappAdded}
            whatsappNumber={whatsappNumber}
            isResponsive={isResponsive}
            onClose={closeShowPreview}
            messages={messages}
            onResetChatAsync={onResetChatAsync}
            onResetChatLoading={onResetChatLoading}
            onShowAlert={(message, variant) => alert.showAlert(message, { variant })}
            isSending={isSending}
          />

          <div className="content" ref={contentRef}>
            <div className="welcome-message">
              <div className="image">{chatBotImage ? <img src={chatBotImage} alt="Chatbot" /> : <ChatbotIcon />}</div>
              <p>{welcomeMessage}</p>
            </div>

            <ChatMessages
              messages={messages}
              color={color}
              textColor={textColor}
              chatBotImage={chatBotImage}
              reactions={reactions}
              handleReaction={handleReaction}
              isSending={isSending}
              isStreaming={isStreaming}
              streamingMessage={streamingMessage}
              isConversationHistoryFetching={isConversationHistoryFetching}
              streamingMessageRef={streamingMessageRef}
            />

            {lead?.fields?.length > 0 && (
              <LeadForm
                lead={lead}
                leadFormik={leadFormik}
                handleFileChange={handleFileChange}
                handleSelectChange={handleSelectChange}
                handleRemoveFile={handleRemoveFile}
                handleTelInputChange={handleTelInputChange}
                handleLeadFormClose={handleLeadFormClose}
                isFieldSubmit={isFieldSubmit}
                isUploadFileLoading={isUploadFileLoading}
                isProcessingFiles={isProcessingFiles}
                uploadedFiles={uploadedFiles}
                fileRef={fileRef}
                color={color}
                textColor={textColor}
                isLeadSubmitLoading={isLeadSubmitLoading}
                isSubmissionSuccess={isSubmissionSuccess}
              />
            )}
          </div>

          <div className="footer">
            <FaqList
              faqs={faqs}
              isSending={isSending}
              updateMessages={updateMessages}
              onFaqStateChange={handleFaqStateChange}
              faqContainerRef={faqContainerRef}
            />
            <MessageInput
              ref={inputRef}
              inputField={inputField}
              isSending={isSending}
              handleChange={handleChange}
              handleEnterKeyPress={handleEnterKeyPress}
              submitForm={submitForm}
              placeholder={messagePlaceholder}
            />
            {additionalNoteEnabled && (
              <div className="additional-note-wrapper" ref={additionalNoteRef}>
                <span>
                  {additionalNoteText}
                  <a href={privacyPolicyDocument?.file} target="_blank" download>
                    {additionalNoteLinkText}
                  </a>
                </span>
              </div>
            )}
            <p className="powered-by">
              Powered by{' '}
              <a href="https://booosted.fi" target="_blank">
                Booosted.fi
              </a>
            </p>
          </div>
        </>
      )}
    </div>
  );
}

export default ChatbotPreview;
